import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { setNotification } from '../../../redux/cache-slice';
import { useAppDispatch } from '../../../redux/store';
import { RootState } from '../../../redux/types';
import { ReactComponent as CheckMarkIcon } from '../../b2b/components/icons/check_circle.svg';
import { ReactComponent as ClosedCircleIcon } from '../../b2b/components/icons/close-circle.svg';
import { ReactComponent as CloseIcon } from '../../b2b/components/icons/close.svg';
import { ReactComponent as WarningIcon } from '../../b2b/components/icons/warning.svg';
import './notification.css';

const Notification = () => {
  // Store Values
  const {
    notificationVisibility,
    notificationTitle,
    notificationBody,
    notificationHasError,
    notificationHasWarning,
  } = useSelector((state: RootState) => state.cache);

  // Dispatch Hook
  const dispatch = useAppDispatch();

  // Timer used for counting width and opacity
  const [timer, setTimer] = useState<number>(-20);

  // Interval to change timer value
  useEffect(() => {
    const interval = setInterval(() => {
      if (
        timer <= 2000 &&
        notificationVisibility &&
        !notificationHasError &&
        !notificationHasWarning
      ) {
        setTimer(timer + 1);
      } else {
        setTimer(-20);
        clearInterval(interval);
      }
    }, 10);

    return () => clearInterval(interval);
  }, [
    notificationHasError,
    notificationHasWarning,
    notificationVisibility,
    timer,
  ]);

  // Control notification visibility with effect
  useEffect(() => {
    if (
      notificationVisibility &&
      !notificationHasError &&
      !notificationHasWarning
    ) {
      setTimeout(() => {
        dispatch(setNotification({ notificationVisibility: false }));
      }, 11400);
    }
  }, [
    dispatch,
    notificationHasError,
    notificationHasWarning,
    notificationVisibility,
  ]);

  // In case of notification not visible show nothing
  if (!notificationVisibility) {
    return <></>;
  }

  return (
    <div
      className={`notification-layout ${notificationHasError ? 'danger' : notificationHasWarning ? 'warning' : ''}`}
      style={{ opacity: `${100 - 100 * (timer * 0.001)}%` }}
    >
      <CloseIcon
        width='20'
        height='20'
        className='notification-close'
        onClick={() =>
          dispatch(setNotification({ notificationVisibility: false }))
        }
      />
      <h1 className='notification-title content-bold text-[15px]!'>
        {notificationHasError ? (
          <ClosedCircleIcon />
        ) : notificationHasWarning ? (
          <WarningIcon />
        ) : (
          <CheckMarkIcon />
        )}
        {notificationTitle}
      </h1>
      <p
        style={{ marginBottom: 0 }}
        className='notification-body content-normal'
      >
        {notificationBody}
      </p>
      {/* <div
        className='notification-loading'
        style={{ width: `${95 * (timer * 0.001)}%` }}
      /> */}
    </div>
  );
};

export default Notification;
